export default __webpack_public_path__ + "static/media/burnAction.a6a514c1.svg";